import {BY_BRAND_BY_ENVIRONMENT, BY_ENVIRONMENT} from './by-environment'

/*
 * hostByEnv и hostByBrandByEnv это типизированные объекты
 * @example proxyPass: hostByBrandByEnv[brand].testing.passport.default
 * @example proxyPass: hostByEnv.testing.passport.default
 */
export const hostByEnv = BY_ENVIRONMENT
export const hostByBrandByEnv = BY_BRAND_BY_ENVIRONMENT
